import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ToastQueue } from '@infinex/ui/components';

import { getTRPCClient } from '../config';

export const GAS_DEPOSIT_TRANSFER_KEY = 'gas-deposit-transfer-id';

export function useGasDepositComplete(refetchGasQuote: () => void) {
  const queryClient = useQueryClient();
  const trpc = getTRPCClient();
  return useMutation({
    ...trpc.gas.completeGasDeposit.mutationOptions(),
    onSuccess: (data) => {
      queryClient.setQueryData([GAS_DEPOSIT_TRANSFER_KEY], data.transferId);
    },
    onMutate: async () => {
      void queryClient.invalidateQueries({
        queryKey: [GAS_DEPOSIT_TRANSFER_KEY],
      });
      return undefined;
    },
    onError: (error) => {
      console.error('Gas Deposit Completion Error:', error);
      if (error instanceof Error) {
        if (error.message.includes('quote expired')) {
          refetchGasQuote();
        }
      }
      // Show error toast
      ToastQueue.add('error', {
        title: 'Gas Top-Up Failed',
        content: 'Unable to complete gas top-up. Please try again.',
        duration: 5000,
      });
    },
  });
}
